/**
 * Content Library — Learn-Mode inline tips.
 *
 * Anchored across `routes/social/ContentLibrary.tsx` and
 * `components/content-library/*`. Covers the pre-approval review queue —
 * distinct from the Approvals tips (`./approvals.ts`), which cover posts
 * already slated for publish.
 */

import type { LearnTip } from "./types";

export const contentLibraryTips: LearnTip[] = [
  {
    key: "content-library",
    title: "Content Library",
    body: "Agents bulk-generate reels, stills, designs and draft briefs. Browse them here and approve or reject before anything is eligible for the Approvals queue or the calendar.",
  },
  {
    key: "content-library-tabs",
    title: "Status",
    body: "Pending is what needs a decision; Approved is ready for the calendar; Rejected is kept for audit, never deleted. All shows every status at once.",
  },
  {
    key: "content-library-filters",
    title: "Filter the library",
    body: "Narrow by content type or where it came from, or search by title. Pick a client at the top to see just their content.",
  },
  {
    key: "content-library-grid",
    title: "Content",
    body: "Click a card's thumbnail to preview it full-size and switch between any alternate crops. The buttons below each card are the one-click review flow and don't require opening the preview first.",
  },
  {
    key: "content-library-actions",
    title: "Review actions",
    body: "Approve is one click. Reject opens an optional reason — leaving it blank is fine. Approved items get an Add to calendar button; either decision can be undone.",
  },
  {
    key: "content-library-to-calendar",
    title: "Add to calendar",
    body: "Places an approved item as a draft post — never scheduled or published automatically. Caption, platforms and the date/time are all optional; leave the date blank to let the brand's next open slot be picked for you.",
  },
  {
    key: "content-library-preview",
    title: "Preview",
    body: "The full media, the caption, where it came from, and — once reviewed — who decided and why. A carousel shows every slide in a strip instead of crop options.",
  },
];
